
// ヘッダーのストーリーセクション
let ticking = false;
let lastScrollTop = 0;

// スクロール対象のコンテナ
const scrollContainer = document.querySelector('.off-canvas--viewport');
const target = document.getElementById('shopify-section-c-story-like');

function handleScroll() {
  let scrollTop = scrollContainer.scrollTop || window.pageYOffset;

  // scrollTop が負の値になっていたら 0 に補正
  if (scrollTop < 0) {
    scrollTop = 0;
    scrollContainer.scrollTop = 0;
  }


  if (target) {
    if (scrollTop === 0) {
      // 最上部にいるときは常に表示
      target.style.top = '78px';
    } else if (scrollTop < lastScrollTop) {
      // 上にスクロール中
      target.style.top = '78px';
    } else if (scrollTop > lastScrollTop) {
      // 下にスクロール中
      target.style.top = '-100px';
      target.style.width = '100%';
    }
  }

  if (scrollTop !== 0) {
    lastScrollTop = scrollTop;
  }

  ticking = false;
}

function onScroll() {
  if (!ticking) {
    requestAnimationFrame(handleScroll);
    ticking = true;
  }
}

if (scrollContainer) {
  scrollContainer.addEventListener('scroll', onScroll);
} else {
  window.addEventListener('scroll', onScroll);
}

// 商品ページの商品画像拡大機能
document.addEventListener('DOMContentLoaded', function () {
  const allImages = Array.from(document.querySelectorAll('.product-media--wrapper img'));
  const productImages = allImages.filter(img => {
    return window.productImageUrls && window.productImageUrls.some(url => img.src.includes(url));
  });

  const mainSlides = document.querySelectorAll('.product-media--wrapper .splide__slide img');
  const openModalTriggers = document.querySelectorAll('.u-product-image--click');

  console.log(openModalTriggers);

  // モーダル生成
  const modal = document.createElement('div');
  modal.id = 'image-modal';
  modal.innerHTML = `
    <div class="modal-overlay"></div>
    <div class="modal-content">
      <button class="modal-close">&times;</button>
      <div class="modal-main-image-wrapper">
        <img class="modal-main-image" src="" alt="main image">
      </div>
      <div class="modal-thumbnails"></div>
    </div>
  `;
  document.body.appendChild(modal);

  const modalElement = document.getElementById('image-modal');
  const mainImageEl = modalElement.querySelector('.modal-main-image');
  const thumbnailsWrapper = modalElement.querySelector('.modal-thumbnails');

  // サムネイル画像とクリック切り替え処理
  productImages.forEach((img, index) => {
    const thumb = document.createElement('img');
    thumb.src = img.src;
    thumb.className = 'modal-thumb';
    thumb.dataset.index = index;
    thumbnailsWrapper.appendChild(thumb);

    thumb.addEventListener('click', () => {
      mainImageEl.src = thumb.src;
      document.querySelectorAll('.modal-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  const showModal = (src) => {
    mainImageEl.src = src;
    modalElement.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    // サムネイルのハイライト処理
    document.querySelectorAll('.modal-thumb').forEach(t => {
      t.classList.toggle('active', t.src === src);
    });
  };

  // 商品画像クリックでもモーダルを表示
  mainSlides.forEach(slide => {
    slide.addEventListener('click', () => {
      showModal(slide.src);
    });
  });

  // トリガークリック時に表示（.is-active な画像 or 最初の画像）
  openModalTriggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const activeImg = document.querySelector('.product-media--wrapper .splide__slide.is-active img');
      const fallbackImg = productImages.length > 0 ? productImages[0] : null;

      if (activeImg) {
        showModal(activeImg.src);
      } else if (fallbackImg) {
        showModal(fallbackImg.src);
      }
    });
  });

  // 閉じる
  const closeModal = () => {
    modalElement.style.display = 'none';
    document.body.style.overflow = '';
  };

  modalElement.querySelector('.modal-close').addEventListener('click', closeModal);
  modalElement.querySelector('.modal-overlay').addEventListener('click', closeModal);
});


  
// ここから無限スクロール
document.addEventListener('DOMContentLoaded', function () {
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 1.0
  };

  let isLoading = false;
  let nextPageUrl = document.querySelector('.pagination--right-arrow')?.closest('a')?.getAttribute('href');
  const productGrid = document.querySelector('.collection--body--grid');
  const spinner = document.querySelector('[data-infinite-scroll-spinner]');

  let observer;

  // 🆕 PrimeReview再初期化関数
  const reinitializePrimeReviewFavorites = () => {
    const scripts = document.querySelectorAll('script[defer]');
    scripts.forEach(script => {
      const content = script.textContent;
      if (content.includes('window.handleClick') && !script.dataset.executed) {
        try {
          new Function(content)();
          script.dataset.executed = 'true';
          console.log('🔁 お気に入りスクリプトを再初期化しました');
        } catch (e) {
          console.error('❌ お気に入りスクリプト再初期化エラー:', e);
        }
      }
    });
  };

  const observeLastItem = () => {
    if (!productGrid || !productGrid.lastElementChild) return;

    if (observer) observer.disconnect();

    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !isLoading && nextPageUrl) {
          isLoading = true;
          if (spinner) spinner.style.display = 'flex';

          fetch(nextPageUrl)
            .then(response => response.text())
            .then(data => {
              const parser = new DOMParser();
              const htmlDoc = parser.parseFromString(data, 'text/html');
              const nextProducts = htmlDoc.querySelectorAll('#collection-root .product-item');
              nextProducts.forEach(item => productGrid.appendChild(item));

              // 次ページURL更新
              nextPageUrl = htmlDoc.querySelector('.pagination--right-arrow')?.closest('a')?.getAttribute('href') || null;

              // pagination削除
              const paginationRoot = document.querySelector('.pagination--root');
              if (paginationRoot) paginationRoot.remove();

              // スピナー非表示
              if (spinner) spinner.style.display = 'none';

              // Prime Review お気に入り初期化
              reinitializePrimeReviewFavorites();

              isLoading = false;
              observeLastItem();
            })
            .catch(err => {
              console.error('Infinite scroll error:', err);
              if (spinner) spinner.style.display = 'none';
              isLoading = false;
            });
        }
      });
    }, observerOptions);

    observer.observe(productGrid.lastElementChild);
  };

  if (productGrid) {
    observeLastItem();
  }
});
